export default __webpack_public_path__ + "static/media/349.003366da.jpg";